module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component.scss
// module id = ./src/app/admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component.scss
// module chunks = main